var _circle, _path, _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _circle2, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgTiktokAdd(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 296,
    viewBox: "0 0 37 296",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 18.2854,
    cy: 34.6448,
    r: 9.14084,
    fill: "#EB4D60"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.2854 30.8359C17.8647 30.8359 17.5236 31.177 17.5236 31.5977V33.8829H15.2384C14.8177 33.8829 14.4767 34.2239 14.4767 34.6446C14.4767 35.0653 14.8177 35.4064 15.2384 35.4064H17.5236V37.6916C17.5236 38.1123 17.8647 38.4533 18.2854 38.4533C18.7061 38.4533 19.0471 38.1123 19.0471 37.6916V35.4064H21.3323C21.753 35.4064 22.0941 35.0653 22.0941 34.6446C22.0941 34.2239 21.753 33.8829 21.3323 33.8829H19.0471V31.5977C19.0471 31.177 18.7061 30.8359 18.2854 30.8359Z",
    fill: "white"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1795_192711)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28.9459 63.4563C28.9459 69.8953 22.5093 74.8653 19.6372 76.7624C18.8058 77.3116 17.7578 77.3109 16.9269 76.7609C14.0553 74.86 7.61731 69.882 7.61731 63.4563C7.61731 62.1786 8.00856 60.9333 8.73563 59.8968C9.4627 58.8603 10.4887 58.0851 11.6684 57.6811C12.8481 57.277 14.1215 57.2646 15.3085 57.6456C16.4954 58.0265 17.5355 58.7816 18.2816 59.8037C19.0277 58.7816 20.0679 58.0265 21.2548 57.6456C22.4417 57.2646 23.7152 57.277 24.8949 57.6811C26.0745 58.0851 27.1006 58.8603 27.8276 59.8968C28.5547 60.9333 28.9459 62.1786 28.9459 63.4563Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_1795_192711)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.93605 87.914C8.29605 88.25 8.47605 88.7 8.47605 89.264C8.47605 89.588 8.41905 89.888 8.30505 90.164C8.19105 90.44 8.01105 90.719 7.76505 91.001C7.52505 91.277 7.21305 91.586 6.82905 91.928C6.68505 92.06 6.52605 92.198 6.35205 92.342C6.17805 92.486 5.98905 92.642 5.78505 92.81H8.55705L8.42205 93.791H4.21905V92.9C4.45905 92.69 4.71105 92.471 4.97505 92.243C5.23905 92.015 5.49105 91.799 5.73105 91.595C6.10305 91.271 6.40305 90.992 6.63105 90.758C6.86505 90.518 7.03605 90.29 7.14405 90.074C7.25805 89.852 7.31505 89.612 7.31505 89.354C7.31505 89.042 7.23105 88.805 7.06305 88.643C6.90105 88.475 6.67005 88.391 6.37005 88.391C6.01005 88.391 5.74905 88.472 5.58705 88.634C5.43105 88.796 5.31105 89.042 5.22705 89.372L4.13805 89.237C4.20405 88.901 4.32105 88.595 4.48905 88.319C4.66305 88.037 4.90605 87.815 5.21805 87.653C5.53005 87.485 5.92905 87.401 6.41505 87.401C7.07505 87.401 7.58205 87.572 7.93605 87.914ZM9.87822 87.572H13.4062V88.544H10.7962L10.6612 90.11C10.9912 89.87 11.3962 89.75 11.8762 89.75C12.3082 89.75 12.6652 89.84 12.9472 90.02C13.2292 90.2 13.4362 90.443 13.5682 90.749C13.7062 91.055 13.7752 91.4 13.7752 91.784C13.7752 92.492 13.5832 93.032 13.1992 93.404C12.8212 93.77 12.3022 93.953 11.6422 93.953C10.9702 93.953 10.4482 93.797 10.0762 93.485C9.70422 93.167 9.49422 92.708 9.44622 92.108H10.5622C10.6102 92.414 10.7122 92.639 10.8682 92.783C11.0302 92.927 11.2792 92.999 11.6152 92.999C11.9452 92.999 12.2002 92.9 12.3802 92.702C12.5602 92.504 12.6502 92.198 12.6502 91.784C12.6502 91.436 12.5692 91.16 12.4072 90.956C12.2512 90.752 11.9872 90.65 11.6152 90.65C11.3872 90.65 11.1892 90.686 11.0212 90.758C10.8592 90.83 10.7092 90.944 10.5712 91.1H9.58122L9.87822 87.572ZM14.5114 90.695C14.5114 89.567 14.7154 88.736 15.1234 88.202C15.5374 87.668 16.1134 87.401 16.8514 87.401C17.5954 87.401 18.1624 87.665 18.5524 88.193C18.9484 88.721 19.1464 89.549 19.1464 90.677C19.1464 91.799 18.9454 92.627 18.5434 93.161C18.1474 93.689 17.5714 93.953 16.8154 93.953C16.0714 93.953 15.5014 93.692 15.1054 93.17C14.7094 92.642 14.5114 91.817 14.5114 90.695ZM17.9584 90.686C17.9584 89.936 17.8774 89.369 17.7154 88.985C17.5534 88.601 17.2594 88.409 16.8334 88.409C16.4074 88.409 16.1104 88.601 15.9424 88.985C15.7804 89.363 15.6994 89.93 15.6994 90.686C15.6994 91.436 15.7804 92.003 15.9424 92.387C16.1104 92.765 16.4074 92.954 16.8334 92.954C17.2594 92.954 17.5534 92.765 17.7154 92.387C17.8774 92.003 17.9584 91.436 17.9584 90.686ZM20.0446 92.459H21.1696L20.6476 94.646H19.7566L20.0446 92.459ZM22.4578 87.572H25.9858V88.544H23.3758L23.2408 90.11C23.5708 89.87 23.9758 89.75 24.4558 89.75C24.8878 89.75 25.2448 89.84 25.5268 90.02C25.8088 90.2 26.0158 90.443 26.1478 90.749C26.2858 91.055 26.3548 91.4 26.3548 91.784C26.3548 92.492 26.1628 93.032 25.7788 93.404C25.4008 93.77 24.8818 93.953 24.2218 93.953C23.5498 93.953 23.0278 93.797 22.6558 93.485C22.2838 93.167 22.0738 92.708 22.0258 92.108H23.1418C23.1898 92.414 23.2918 92.639 23.4478 92.783C23.6098 92.927 23.8588 92.999 24.1948 92.999C24.5248 92.999 24.7798 92.9 24.9598 92.702C25.1398 92.504 25.2298 92.198 25.2298 91.784C25.2298 91.436 25.1488 91.16 24.9868 90.956C24.8308 90.752 24.5668 90.65 24.1948 90.65C23.9668 90.65 23.7688 90.686 23.6008 90.758C23.4388 90.83 23.2888 90.944 23.1508 91.1H22.1608L22.4578 87.572ZM27.406 87.365H28.612V90.2L31.222 87.365H32.536L30.331 89.759L32.77 93.791H31.429L29.512 90.605L28.612 91.559V93.791H27.406V87.365Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d_1795_192711)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.9459 118.501C28.9459 118.826 28.9252 119.146 28.8847 119.462C28.5765 122.759 25.6781 127.15 19.5437 129.372C19.2993 129.46 19.0433 129.277 19.0433 129.017V127.255C18.917 127.259 18.79 127.261 18.6625 127.261C12.9831 127.261 8.37903 123.339 8.37903 118.501C8.37903 113.663 12.9831 109.741 18.6625 109.741C24.3419 109.741 28.9459 113.663 28.9459 118.501ZM14.4729 120.405C15.3143 120.405 15.9964 119.723 15.9964 118.882C15.9964 118.04 15.3143 117.358 14.4729 117.358C13.6315 117.358 12.9495 118.04 12.9495 118.882C12.9495 119.723 13.6315 120.405 14.4729 120.405ZM19.0433 120.405C19.8847 120.405 20.5668 119.723 20.5668 118.882C20.5668 118.04 19.8847 117.358 19.0433 117.358C18.2019 117.358 17.5199 118.04 17.5199 118.882C17.5199 119.723 18.2019 120.405 19.0433 120.405ZM25.1372 118.882C25.1372 119.723 24.4552 120.405 23.6138 120.405C22.7724 120.405 22.0903 119.723 22.0903 118.882C22.0903 118.04 22.7724 117.358 23.6138 117.358C24.4552 117.358 25.1372 118.04 25.1372 118.882Z",
    fill: "white"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_d_1795_192711)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.0498 146.163H9.88876V141.204L8.63776 142.005L8.12476 141.177L10.0508 139.944H11.0498V146.163ZM12.9469 143.067C12.9469 141.939 13.1509 141.108 13.5589 140.574C13.9729 140.04 14.5489 139.773 15.2869 139.773C16.0309 139.773 16.5979 140.037 16.9879 140.565C17.3839 141.093 17.5819 141.921 17.5819 143.049C17.5819 144.171 17.3809 144.999 16.9789 145.533C16.5829 146.061 16.0069 146.325 15.2509 146.325C14.5069 146.325 13.9369 146.064 13.5409 145.542C13.1449 145.014 12.9469 144.189 12.9469 143.067ZM16.3939 143.058C16.3939 142.308 16.3129 141.741 16.1509 141.357C15.9889 140.973 15.6949 140.781 15.2689 140.781C14.8429 140.781 14.5459 140.973 14.3779 141.357C14.2159 141.735 14.1349 142.302 14.1349 143.058C14.1349 143.808 14.2159 144.375 14.3779 144.759C14.5459 145.137 14.8429 145.326 15.2689 145.326C15.6949 145.326 15.9889 145.137 16.1509 144.759C16.3129 144.375 16.3939 143.808 16.3939 143.058ZM18.1831 143.067C18.1831 141.939 18.3871 141.108 18.7951 140.574C19.2091 140.04 19.7851 139.773 20.5231 139.773C21.2671 139.773 21.8341 140.037 22.2241 140.565C22.6201 141.093 22.8181 141.921 22.8181 143.049C22.8181 144.171 22.6171 144.999 22.2151 145.533C21.8191 146.061 21.2431 146.325 20.4871 146.325C19.7431 146.325 19.1731 146.064 18.7771 145.542C18.3811 145.014 18.1831 144.189 18.1831 143.067ZM21.6301 143.058C21.6301 142.308 21.5491 141.741 21.3871 141.357C21.2251 140.973 20.9311 140.781 20.5051 140.781C20.0791 140.781 19.7821 140.973 19.6141 141.357C19.4521 141.735 19.3711 142.302 19.3711 143.058C19.3711 143.808 19.4521 144.375 19.6141 144.759C19.7821 145.137 20.0791 145.326 20.5051 145.326C20.9311 145.326 21.2251 145.137 21.3871 144.759C21.5491 144.375 21.6301 143.808 21.6301 143.058ZM23.7343 139.737H24.9403V142.572L27.5503 139.737H28.8643L26.6593 142.131L29.0983 146.163H27.7573L25.8403 142.977L24.9403 143.931V146.163H23.7343V139.737Z",
    fill: "white"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_d_1795_192711)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.90259 164.387C9.90259 163.552 10.5847 162.875 11.4261 162.875H25.1373C25.9787 162.875 26.6608 163.552 26.6608 164.387V180.399C26.6608 180.996 25.9972 181.357 25.4901 181.037L18.6907 176.742C18.4411 176.584 18.1223 176.584 17.8727 176.742L11.0733 181.037C10.5662 181.357 9.90259 180.996 9.90259 180.399V164.387Z",
    fill: "white"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter5_d_1795_192711)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.0309 192.64C11.3909 192.31 11.9339 192.145 12.6599 192.145C13.3919 192.145 13.9319 192.31 14.2799 192.64C14.6339 192.964 14.8109 193.384 14.8109 193.9C14.8109 194.266 14.7269 194.569 14.5589 194.809C14.3969 195.043 14.1869 195.217 13.9289 195.331C14.2049 195.433 14.4509 195.61 14.6669 195.862C14.8829 196.108 14.9909 196.435 14.9909 196.843C14.9909 197.413 14.7959 197.866 14.4059 198.202C14.0159 198.532 13.4279 198.697 12.6419 198.697C11.8619 198.697 11.2769 198.532 10.8869 198.202C10.4969 197.872 10.3019 197.422 10.3019 196.852C10.3019 196.582 10.3529 196.348 10.4549 196.15C10.5629 195.952 10.6979 195.787 10.8599 195.655C11.0279 195.517 11.1989 195.415 11.3729 195.349C11.1149 195.235 10.9019 195.061 10.7339 194.827C10.5719 194.587 10.4909 194.281 10.4909 193.909C10.4909 193.393 10.6709 192.97 11.0309 192.64ZM12.6599 197.788C13.0859 197.788 13.3949 197.698 13.5869 197.518C13.7789 197.338 13.8749 197.092 13.8749 196.78C13.8749 196.486 13.7849 196.252 13.6049 196.078C13.4249 195.904 13.1069 195.817 12.6509 195.817C12.2009 195.817 11.8829 195.904 11.6969 196.078C11.5169 196.252 11.4269 196.489 11.4269 196.789C11.4269 197.095 11.5259 197.338 11.7239 197.518C11.9219 197.698 12.2339 197.788 12.6599 197.788ZM12.6419 194.917C13.0259 194.917 13.3049 194.839 13.4789 194.683C13.6589 194.527 13.7489 194.293 13.7489 193.981C13.7489 193.717 13.6619 193.495 13.4879 193.315C13.3199 193.135 13.0379 193.045 12.6419 193.045C12.2519 193.045 11.9699 193.138 11.7959 193.324C11.6279 193.504 11.5439 193.726 11.5439 193.99C11.5439 194.302 11.6309 194.536 11.8049 194.692C11.9849 194.842 12.2639 194.917 12.6419 194.917ZM17.743 198.697C17.143 198.697 16.666 198.559 16.312 198.283C15.964 198.001 15.763 197.584 15.709 197.032H16.798C16.846 197.29 16.945 197.476 17.095 197.59C17.251 197.704 17.467 197.761 17.743 197.761C18.139 197.761 18.436 197.605 18.634 197.293C18.838 196.975 18.94 196.426 18.94 195.646C18.586 196.09 18.1 196.312 17.482 196.312C17.056 196.312 16.702 196.225 16.42 196.051C16.138 195.877 15.928 195.637 15.79 195.331C15.652 195.025 15.583 194.677 15.583 194.287C15.583 193.855 15.673 193.48 15.853 193.162C16.033 192.838 16.288 192.589 16.618 192.415C16.948 192.235 17.338 192.145 17.788 192.145C18.214 192.145 18.571 192.226 18.859 192.388C19.147 192.544 19.375 192.763 19.543 193.045C19.717 193.321 19.843 193.642 19.921 194.008C19.999 194.374 20.038 194.761 20.038 195.169C20.038 195.853 19.969 196.462 19.831 196.996C19.693 197.524 19.456 197.941 19.12 198.247C18.79 198.547 18.331 198.697 17.743 198.697ZM18.859 194.296C18.859 194.08 18.82 193.879 18.742 193.693C18.67 193.507 18.556 193.357 18.4 193.243C18.244 193.123 18.046 193.063 17.806 193.063C17.464 193.063 17.191 193.171 16.987 193.387C16.789 193.597 16.69 193.888 16.69 194.26C16.69 194.596 16.768 194.878 16.924 195.106C17.08 195.328 17.35 195.439 17.734 195.439C18.04 195.439 18.304 195.346 18.526 195.16C18.748 194.974 18.859 194.686 18.859 194.296ZM21.1162 192.109H22.3222V194.944L24.9322 192.109H26.2462L24.0412 194.503L26.4802 198.535H25.1392L23.2222 195.349L22.3222 196.303V198.535H21.1162V192.109Z",
    fill: "white"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter6_d_1795_192711)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.5151 214.709C19.0352 214.23 18.2147 214.569 18.2147 215.248L18.2147 219.503C13.7841 220.193 9.00931 222.168 8.38157 230.524C8.32983 231.213 9.07952 231.481 9.57503 231C10.8269 229.784 13.1402 228.383 18.2147 228.383L18.2147 232.899C18.2147 233.577 19.0352 233.917 19.5151 233.437L27.8018 225.151C28.3967 224.556 28.3967 223.591 27.8018 222.996L19.5151 214.709Z",
    fill: "white"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter7_d_1795_192711)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.37805 250.907H6.21705V245.948L4.96605 246.749L4.45305 245.921L6.37905 244.688H7.37805V250.907ZM13.2532 250.529C12.8872 250.889 12.3412 251.069 11.6152 251.069C11.0572 251.069 10.6102 250.973 10.2742 250.781C9.94422 250.589 9.70422 250.34 9.55422 250.034C9.41022 249.722 9.33522 249.389 9.32922 249.035H10.4272C10.4572 249.389 10.5592 249.656 10.7332 249.836C10.9132 250.016 11.1982 250.106 11.5882 250.106C11.9302 250.106 12.1912 250.019 12.3712 249.845C12.5572 249.671 12.6502 249.422 12.6502 249.098C12.6502 248.762 12.5572 248.522 12.3712 248.378C12.1852 248.228 11.9272 248.153 11.5972 248.153H10.9762V247.226H11.6242C11.9062 247.226 12.1282 247.151 12.2902 247.001C12.4522 246.845 12.5332 246.62 12.5332 246.326C12.5332 246.062 12.4492 245.858 12.2812 245.714C12.1192 245.57 11.8792 245.498 11.5612 245.498C11.2312 245.498 10.9822 245.57 10.8142 245.714C10.6522 245.858 10.5292 246.089 10.4452 246.407L9.38322 246.281C9.43722 245.951 9.54822 245.654 9.71622 245.39C9.88422 245.126 10.1242 244.916 10.4362 244.76C10.7482 244.598 11.1442 244.517 11.6242 244.517C12.2962 244.517 12.8032 244.676 13.1452 244.994C13.4872 245.306 13.6582 245.699 13.6582 246.173C13.6582 246.851 13.3702 247.325 12.7942 247.595C13.1362 247.733 13.3912 247.934 13.5592 248.198C13.7272 248.456 13.8112 248.765 13.8112 249.125C13.8112 249.701 13.6252 250.169 13.2532 250.529ZM18.4084 245.03C18.7684 245.366 18.9484 245.816 18.9484 246.38C18.9484 246.704 18.8914 247.004 18.7774 247.28C18.6634 247.556 18.4834 247.835 18.2374 248.117C17.9974 248.393 17.6854 248.702 17.3014 249.044C17.1574 249.176 16.9984 249.314 16.8244 249.458C16.6504 249.602 16.4614 249.758 16.2574 249.926H19.0294L18.8944 250.907H14.6914V250.016C14.9314 249.806 15.1834 249.587 15.4474 249.359C15.7114 249.131 15.9634 248.915 16.2034 248.711C16.5754 248.387 16.8754 248.108 17.1034 247.874C17.3374 247.634 17.5084 247.406 17.6164 247.19C17.7304 246.968 17.7874 246.728 17.7874 246.47C17.7874 246.158 17.7034 245.921 17.5354 245.759C17.3734 245.591 17.1424 245.507 16.8424 245.507C16.4824 245.507 16.2214 245.588 16.0594 245.75C15.9034 245.912 15.7834 246.158 15.6994 246.488L14.6104 246.353C14.6764 246.017 14.7934 245.711 14.9614 245.435C15.1354 245.153 15.3784 244.931 15.6904 244.769C16.0024 244.601 16.4014 244.517 16.8874 244.517C17.5474 244.517 18.0544 244.688 18.4084 245.03ZM20.0446 249.575H21.1696L20.6476 251.762H19.7566L20.0446 249.575ZM22.4578 244.688H25.9858V245.66H23.3758L23.2408 247.226C23.5708 246.986 23.9758 246.866 24.4558 246.866C24.8878 246.866 25.2448 246.956 25.5268 247.136C25.8088 247.316 26.0158 247.559 26.1478 247.865C26.2858 248.171 26.3548 248.516 26.3548 248.9C26.3548 249.608 26.1628 250.148 25.7788 250.52C25.4008 250.886 24.8818 251.069 24.2218 251.069C23.5498 251.069 23.0278 250.913 22.6558 250.601C22.2838 250.283 22.0738 249.824 22.0258 249.224H23.1418C23.1898 249.53 23.2918 249.755 23.4478 249.899C23.6098 250.043 23.8588 250.115 24.1948 250.115C24.5248 250.115 24.7798 250.016 24.9598 249.818C25.1398 249.62 25.2298 249.314 25.2298 248.9C25.2298 248.552 25.1488 248.276 24.9868 248.072C24.8308 247.868 24.5668 247.766 24.1948 247.766C23.9668 247.766 23.7688 247.802 23.6008 247.874C23.4388 247.946 23.2888 248.06 23.1508 248.216H22.1608L22.4578 244.688ZM27.406 244.481H28.612V247.316L31.222 244.481H32.536L30.331 246.875L32.77 250.907H31.429L29.512 247.721L28.612 248.675V250.907H27.406V244.481Z",
    fill: "white"
  }))), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 18.2817,
    cy: 280.568,
    r: 15.2347,
    fill: "url(#paint0_linear_1795_192711)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1795_192711",
    x: 6.85559,
    y: 55.8452,
    width: 24.3756,
    height: 24.3755,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0.761737,
    dy: 0.761737
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.380869
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1795_192711"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1795_192711",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_1795_192711",
    x: 4.13806,
    y: 87.3652,
    width: 30.1554,
    height: 8.80424,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0.761737,
    dy: 0.761737
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.380869
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1795_192711"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1795_192711",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_1795_192711",
    x: 6.85559,
    y: 108.217,
    width: 24.3756,
    height: 24.3755,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0.761737,
    dy: 0.761737
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.380869
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1795_192711"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1795_192711",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_d_1795_192711",
    x: 8.12476,
    y: 139.737,
    width: 22.497,
    height: 8.11136,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0.761737,
    dy: 0.761737
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.380869
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1795_192711"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1795_192711",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_d_1795_192711",
    x: 6.85559,
    y: 160.589,
    width: 24.3756,
    height: 24.3755,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0.761737,
    dy: 0.761737
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.380869
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1795_192711"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1795_192711",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter5_d_1795_192711",
    x: 10.3019,
    y: 192.109,
    width: 17.7018,
    height: 8.11136,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0.761737,
    dy: 0.761737
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.380869
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1795_192711"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1795_192711",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter6_d_1795_192711",
    x: 6.85559,
    y: 212.961,
    width: 24.3756,
    height: 24.3755,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0.761737,
    dy: 0.761737
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.380869
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1795_192711"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1795_192711",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter7_d_1795_192711",
    x: 4.453,
    y: 244.481,
    width: 29.8405,
    height: 8.80424,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0.761737,
    dy: 0.761737
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.380869
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1795_192711"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1795_192711",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1795_192711",
    x1: 18.2817,
    y1: 265.333,
    x2: 18.2817,
    y2: 295.803,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#505050"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#181818"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#505050"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTiktokAdd);
export default __webpack_public_path__ + "static/media/tiktokAdd.58669376.svg";
export { ForwardRef as ReactComponent };